import apiClient from '../config/api';

export const getGiftCardTransactions = async (startDate, endDate, sortBy = 'TransactionDate', sortOrder = 'DESC', page = 1, pageSize = 10) => {
    const response = await apiClient.get('/api/giftcards/report/transactions', {
        params: {
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
            sortBy,
            sortOrder,
            page,
            pageSize
        }
    });

    return response.data;
};

export const downloadGiftCardTransactions = async (startDate, endDate, format = 'excel') => {
    const response = await apiClient.get('/api/giftcards/report/transactions', {
        params: {
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
            format
        },
        responseType: format === 'json' ? 'json' : 'blob'
    });

    // For JSON response
    if (format === 'json') {
        return response.data;
    }

    // For file downloads
    const blob = response.data;
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    // Use .xlsx extension for Excel files
    a.download = `giftcard_transactions.${format === 'excel' ? 'xlsx' : format}`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
};

export const getGiftCardSales = async (startDate, endDate) => {
    const response = await apiClient.get('/api/giftcards/report/purchases', {
        params: {
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString()
        }
    });

    return response.data;
};

export const getGiftCardSalesByWaiter = async (startDate, endDate) => {
    const response = await apiClient.get('/api/giftcards/report/sold-by-waiter', {
        params: {
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString()
        }
    });

    return response.data;
};

export const getFullGiftCardSoldReport = async (startDate, endDate, sortBy = 'SoldDate', sortOrder = 'DESC', page = 1, pageSize = 25, exportAll = false) => {
    const response = await apiClient.get('/api/giftcards/report/full-sold', {
        params: {
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
            sortBy,
            sortOrder,
            page,
            pageSize,
            exportAll: exportAll.toString() // Ensure boolean is converted to string
        }
    });

    return response.data;
};

export const getRewardGiveoutReport = async (startDate, endDate, sortBy = 'RewardHandoutDate', sortOrder = 'DESC', page = 1, pageSize = 10) => {
    const response = await apiClient.get('/api/members/report/reward-giveout', {
        params: {
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
            sortBy,
            sortOrder,
            page,
            pageSize
        }
    });

    return response.data;
};

export const downloadRewardGiveoutReport = async (startDate, endDate, format = 'excel') => {
    const response = await apiClient.get('/api/members/report/reward-giveout', {
        params: {
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
            format
        },
        responseType: format === 'json' ? 'json' : 'blob'
    });

    // For JSON response
    if (format === 'json') {
        return response.data;
    }

    // For file downloads
    const blob = response.data;
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    // Use .xlsx extension for Excel files
    a.download = `reward_giveout_report.${format === 'excel' ? 'xlsx' : format}`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
};

export const getTopSpenderReport = async (startDate, endDate, topN = 10) => {
    const response = await apiClient.get('/api/members/report/top-spender', {
        params: {
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
            topN
        }
    });

    return response.data;
};

export const downloadTopSpenderReport = async (startDate, endDate, topN, format = 'excel') => {
    const response = await apiClient.get('/api/members/report/top-spender', {
        params: {
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
            topN,
            format
        },
        responseType: format === 'json' ? 'json' : 'blob'
    });

    // For JSON response
    if (format === 'json') {
        return response.data;
    }

    // For file downloads
    const blob = response.data;
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    // Use .xlsx extension for Excel files
    a.download = `top_spender_report.${format === 'excel' ? 'xlsx' : format}`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
};

export const getAgeDistributionReport = async () => {
    const response = await apiClient.get('/api/members/report/age-distribution');
    return response.data;
};
